var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

showHideSubscribe();
scrollToPoint();
pagination();
gallery();

function showHideSubscribe() {
    window.addEventListener('scroll', function () {
        'use strict';
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    });

    function portalButton() {
        'use strict';
        st = window.scrollY;

        if (st > 300) {
            body.classList.add('portal-visible');
        } else {
            body.classList.remove('portal-visible');
        }
    }
}

function scrollToPoint() {
    $('.nav-games').on('click', function() {
        $("html, body").stop().animate({scrollTop:$('#games').offset().top}, 'slow');
    });

    $('.nav-news').on('click', function() {
        $("html, body").stop().animate({scrollTop:$('#news').offset().top}, 'slow');
    });

    $('.nav-videos').on('click', function() {
        $("html, body").stop().animate({scrollTop:$('#videos').offset().top}, 'slow');
    });

    $('.nav-media').on('click', function() {
        $("html, body").stop().animate({scrollTop:$('#media').offset().top}, 'slow');
    });

    $('.nav-faq').on('click', function() {
        $("html, body").stop().animate({scrollTop:$('#game-details').offset().top}, 'slow');
    });
}

function pagination() {
    'use strict';

    var wrapper = document.querySelector('.post-feed');
    if (!wrapper) {
        return;
    }

    var wrapper = $('.post-feed');
    var button = $('.infinite-scroll-button');

    wrapper.on('request.infiniteScroll', function (event, path) {
        button.hide();
    });

    wrapper.on('load.infiniteScroll', function (event, response, path) {
        if ($(response).find('body').hasClass('paged-next')) {
            button.show();
        }
    });

    wrapper.infiniteScroll({
        append: '.post-card',
        button: '.infinite-scroll-button',
        debug: false,
        hideNav: '.pagination',
        history: false,
        path: '.pagination .older-posts',
        scrollThreshold: false,
        status: '.infinite-scroll-status',
    });
}

function gallery() {
    'use strict';
    pswp('.kg-gallery-container', '.kg-gallery-image', '.kg-gallery-image', false, true);
}

function pswp(container, element, trigger, caption, isGallery) {
    var parseThumbnailElements = function (el) {
        var items = [],
            gridEl,
            linkEl,
            item;

        el
            .querySelectorAll(element)
            .forEach(function (v) {
                gridEl = v;
                linkEl = gridEl.querySelector(trigger);

                item = {
                    src: isGallery
                        ? gridEl.querySelector('img').getAttribute('src')
                        : linkEl.getAttribute('href'),
                    w: 0,
                    h: 0,
                };

                if (caption && gridEl.querySelector(caption)) {
                    item.title = gridEl.querySelector(caption).innerHTML;
                }

                items.push(item);
            });

        return items;
    };

    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0], gallery, options, items;

        items = parseThumbnailElements(galleryElement);

        options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                // unknown size
                var img = new Image();
                img.onload = function () {
                    // will get size after load
                    item.w = this.width; // set image width
                    item.h = this.height; // set image height
                    gallery.updateSize(true); // reinit Items
                };
                img.src = item.src; // let's download image
            }
        });
        gallery.init();
    };

    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var siblings = e.target.closest(container).querySelectorAll(element);
        var nodes = Array.prototype.slice.call(siblings);
        var index = nodes.indexOf(e.target.closest(element));
        var clickedGallery = e.target.closest(container);

        openPhotoSwipe(index, clickedGallery);

        return false;
    };

    // container = document.querySelector(container);
    // if (!container) return;

    var triggers = document.querySelectorAll(trigger);
    triggers.forEach(function (trig) {
        trig.addEventListener('click', function (e) {
            onThumbnailsClick(e);
        });
    });
}